module.exports = __webpack_public_path__ + "img/topic.34410801.png";